export const getOpenViews = state => state.appState.desktopOpenViews;
export const getActiveViewId = state => state.appState.desktopOpenViews.activeView;
